/**
 * PremiumBadge — a small gold US structure fire-helmet icon shown in front of
 * premium players' names anywhere the UI displays a user (HUD, alliance roster,
 * chat, shared-call requesters, helper rows). Custom inline SVG of a side-view
 * leather "New Yorker" style fire helmet (long rear brim, short front brim,
 * comb across the top, escutcheon on the front).
 */

function FireHelmetSideView({ size = 12 }) {
  // Side-view US structure fire helmet silhouette + accents. Drawn in a 32x32
  // viewBox so it reads cleanly at sizes as small as 10 px. currentColor
  // drives the helmet body so callers can re-skin via inline `style.color`.
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      {/* Helmet body: dome + long rear brim + short front brim silhouette. */}
      <path
        d="M2.5 22.5
           C 4.5 20.5, 6 19.5, 7.5 18
           C 7 12.5, 10 8, 16 8
           C 22 8, 25 12.5, 24.5 18
           C 26 19, 27.5 19.8, 29.5 20.5
           L 29.5 22
           C 27 22.5, 24.5 22.2, 23 21.2
           C 22.2 19.5, 20 18.6, 16 18.6
           C 11.5 18.6, 9 19.5, 8.2 21.4
           C 6.5 22.5, 4 22.8, 2.5 23.2
           Z"
        fill="currentColor"
      />
      {/* Comb / peak ridge running front-to-back along the top of the dome. */}
      <path
        d="M15 8.5
           Q 16 6, 17 8.5
           L 17 17
           L 15 17
           Z"
        fill="rgba(120, 60, 0, 0.55)"
      />
      {/* Front escutcheon / leather shield. */}
      <path
        d="M19.5 11.5
           L 23 11.5
           L 23.6 16
           L 21.2 17.3
           L 18.8 16
           Z"
        fill="rgba(90, 30, 0, 0.85)"
      />
      {/* Small highlight stripe on the front shield for depth. */}
      <path
        d="M20.3 12.5 L 22.4 12.5"
        stroke="rgba(255, 220, 130, 0.9)"
        strokeWidth="0.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default function PremiumBadge({ size = 12, className = "" }) {
  return (
    <span
      data-testid="premium-badge"
      title="Premium member"
      className={`inline-flex items-center justify-center ${className}`}
      style={{
        color: "#FFC939" /* fire-helmet gold */,
        filter: "drop-shadow(0 0 2px rgba(255, 201, 57, 0.6))",
      }}
    >
      <FireHelmetSideView size={size} />
    </span>
  );
}
